__turbopack_context__.v({
  "actions": "VBQ7kG_actions",
  "arrow": "VBQ7kG_arrow",
  "bullets": "VBQ7kG_bullets",
  "content": "VBQ7kG_content",
  "controls": "VBQ7kG_controls",
  "description": "VBQ7kG_description",
  "dot": "VBQ7kG_dot",
  "eyebrow": "VBQ7kG_eyebrow",
  "heading": "VBQ7kG_heading",
  "infoCards": "VBQ7kG_infoCards",
  "overlay": "VBQ7kG_overlay",
  "primaryAction": "VBQ7kG_primaryAction",
  "studio": "VBQ7kG_studio",
  "therapy": "VBQ7kG_therapy",
});
